import Web3 from "web3";
import { ethers } from "ethers";
import { getContractAbi } from "./api";
import { PROXY_CONTRACT_ADDRESS } from "../constants/config";

const web3 = new Web3(Web3.givenProvider);

export function listItem(address,nftId,price,erc20Token,cb) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await getContractAbi()
      if (result.success) {
        const abi = JSON.parse(result.message.result)
        const contract = new web3.eth.Contract(abi, PROXY_CONTRACT_ADDRESS)
        contract.methods.list(nftId,ethers.utils.parseUnits((price).toString(), 18),erc20Token).send({
          from: address
        }).on('transactionHash', function () {
          cb(true)
        }).then(result => {
          resolve(true)
        }).catch(e => {
          console.log(e)
          reject(false)
        })
      } 
    }
    catch (e) {
      console.log(e)
      reject(e)
    }
  })
}

export function buyItem(address,nftId,price,cb) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await getContractAbi()
      if (result.success) {
        const abi = JSON.parse(result.message.result)
        const contract = new web3.eth.Contract(abi, PROXY_CONTRACT_ADDRESS)
        contract.methods.buy(nftId).send({
          from: address,
          value: price.toString()
        }).on('transactionHash', function () {
          cb(true)
        }).then(result => {
          resolve(true)
        }).catch(e => {
          console.log(e)
          reject(false)
        })
      } 
    }
    catch (e) {
      console.log(e)
      reject(e)
    }
  })
}

export function cancelListItem(address, nftId, cb) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await getContractAbi()
      if (result.success) {
        const abi = JSON.parse(result.message.result)
        const contract = new web3.eth.Contract(abi, PROXY_CONTRACT_ADDRESS)
        contract.methods.delist(nftId).send({
          from: address
        }).on('transactionHash', function () {
          cb(true)
        }).then(result => {
          resolve(true)
        }).catch(e => {
          console.log(e)
          reject(false)
        })
      } 
    }
    catch (e) {
      console.log(e)
      reject(e)
    }
  })
}

export function withdraw(address,cb) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await getContractAbi()
      if (result.success) {
        const abi = JSON.parse(result.message.result)
        const contract = new web3.eth.Contract(abi, PROXY_CONTRACT_ADDRESS)
        contract.methods.withdrawPayments(address).send({
          from: address
        }).on('transactionHash', function () {
          cb(true)
        }).then(result => {
          resolve(true)
        }).catch(e => {
          console.log(e)
          reject(false)
        })
      } 
    }
    catch (e) {
      console.log(e)
      reject(e)
    }
  })
}

export function getWithdrawBalance(address) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await getContractAbi()
      if (result.success) {
        const abi = JSON.parse(result.message.result)
        const contract = new web3.eth.Contract(abi, PROXY_CONTRACT_ADDRESS)
        const balance = await contract.methods.payments(address).call()
        resolve(balance)
      } 
    }
    catch (e) {
      console.log(e)
      reject(0)
    }
  })
}